// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialer-wrapper[data-v-56132d9e] {
  position: fixed;
  width: 100%;
  z-index: 999;
}
.dialer-wrapper .dialer-contain[data-v-56132d9e] {
  position: absolute;
  top: var(--dialer-top);
  left: var(--dialer-left);
  background-color: var(--dialer-bgcolor);
  z-index: 9999;
  -webkit-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
}
.dialer-wrapper .dialer-contain[data-v-56132d9e]::before {
  content: '';
  position: absolute;
  top: -13px;
  left: var(--mouth-left);
  width: 0;
  height: 0;
  border-top: 14px solid transparent;
  border-right: 19px solid var(--dialer-bgcolor);
}
.dialer-wrapper .dialer[data-v-56132d9e] {
  user-select: none;
  overflow: hidden;
  height: 500px;
  width: 300px;
}
.dialer-wrapper .dialer .head[data-v-56132d9e] {
  background-color: var(--dialer-bgcolor);
  display: flex;
  padding: 10px 20px 0px 15px;
  height: 35px;
}
.dialer-wrapper .dialer .head .close-btn[data-v-56132d9e] {
  margin: auto 0 auto auto;
  opacity: .2;
  cursor: pointer;
}
.dialer-wrapper .dialer .head .close-btn i[data-v-56132d9e] {
  font-weight: 900;
}
.dialer-wrapper .dialer .phone-wrapper[data-v-56132d9e] {
  margin: auto -20px;
  height: 68px;
  display: flex;
  flex-direction: column;
  font-size: .9em;
}
.dialer-wrapper .dialer .phone-wrapper .phone[data-v-56132d9e] {
  display: flex;
  margin: 5px auto 0 auto;
}
.dialer-wrapper .dialer .phone-wrapper .phone .fake-caret[data-v-56132d9e] {
  content: ' ';
  width: .5px;
  position: absolute;
  height: 53.5px;
  margin: -5px auto auto 48%;
  background-color: var(--dialer-bgcolor);
  animation: cepheid-56132d9e 1.2s linear infinite;
  z-index: 9999;
}
.dialer-wrapper .dialer .phone-wrapper .phone .replace[data-v-56132d9e] {
  position: absolute;
  width: 267px;
  margin-top: -13px;
  margin-left: 34px;
  text-align: center;
  min-height: 68px;
  padding: 0;
  color: var(--dialer-input-color);
  vertical-align: bottom;
  display: flex;
  align-items: flex-end;
  background-color: var(--dialer-bgcolor);
}
.dialer-wrapper .dialer .phone-wrapper .phone .replace.hide-fake-input[data-v-56132d9e] {
  background: transparent;
  pointer-events: none;
  color: transparent;
}
.dialer-wrapper .dialer .phone-wrapper .phone .replace .fake-input[data-v-56132d9e] {
  display: flex;
  margin: auto;
}
.dialer-wrapper .dialer .phone-wrapper .phone .replace .fake-input-placeholder[data-v-56132d9e] {
  display: flex;
  margin: auto;
  color: var(--custom-textarea-color);
  font-weight: 400;
  font-size: .8em;
}
.dialer-wrapper .dialer .phone-wrapper .phone .icon[data-v-56132d9e] {
  display: flex;
  opacity: 0;
}
.dialer-wrapper .dialer .phone-wrapper .phone .icon.show[data-v-56132d9e] {
  opacity: 1;
}
.dialer-wrapper .dialer .phone-wrapper .phone .input[data-v-56132d9e] {
  text-align: center;
  min-height: 60px;
}
.dialer-wrapper .dialer .phone-wrapper .phone .input.show-true-input[data-v-56132d9e] {
  color: #3F3F3F;
}
.dialer-wrapper .dialer .phone-wrapper .phone .input.show-true-input input[data-v-56132d9e]::selection {
  background: #3F3F3F;
  color: gray;
}
.dialer-wrapper .dialer .phone-wrapper .phone .input.show-true-input input[data-v-56132d9e]::-moz-selection {
  background: #3F3F3F;
  color: gray;
}
.dialer-wrapper .dialer .phone-wrapper .phone .input .phone-string[data-v-56132d9e] {
  user-select: text;
  text-align: center;
  display: flex;
  width: 240px;
  min-height: 68px;
  border: none;
  outline: none;
  margin-top: -13px;
  margin-left: 45px;
}
.dialer-wrapper .dialer .phone-wrapper .phone .backspace[data-v-56132d9e] {
  cursor: pointer;
  display: flex;
  margin: auto;
  width: 48px;
  font-size: 1.5em;
  color: #ccc;
  opacity: 0;
  transition-property: opacity;
  transition-duration: .25s;
  position: relative;
}
.dialer-wrapper .dialer .phone-wrapper .phone .backspace.show[data-v-56132d9e] {
  opacity: 1;
  cursor: pointer;
  transition-property: opacity;
  transition-duration: .25s;
}
.dialer-wrapper .dialer .phone-wrapper .phone .backspace i[data-v-56132d9e] {
  position: absolute;
  top: -8px;
  left: -27px;
  transform: translate(24px, -9px);
}
.dialer-wrapper .dialer .phone-wrapper .phone .backspace i.fa-backspace[data-v-56132d9e]::before {
  font-weight: 100;
}
.dialer-wrapper .dialer .person-name[data-v-56132d9e] {
  color: #7E7E7E;
  display: flex;
  margin: -20px auto;
}
.dialer-wrapper .dialer .dialpad[data-v-56132d9e] {
  line-height: 70px;
  height: 278px;
}
.dialer-wrapper .dialer .dialpad .dialpad-row[data-v-56132d9e] {
  display: flex;
  width: 100%;
  margin: 15px auto;
  color: var(--dialer-color);
}
.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col[data-v-56132d9e] {
  width: 80px;
  text-align: center;
  margin: auto;
  font-weight: 100;
  font-size: 32px;
  cursor: pointer;
}
.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.asterisk[data-v-56132d9e] {
  color: var(--dialer-color-special);
}
.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.hash[data-v-56132d9e] {
  color: var(--dialer-color-special);
}
.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.combo[data-v-56132d9e] {
  display: flex;
  flex-direction: column;
  line-height: 25px;
  transform: translateY(12.5px);
}
.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.combo .letters[data-v-56132d9e] {
  font-size: 10px;
  font-weight: 100;
  color: var(--dialer-color-special);
}
.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.combo .letters.invisible[data-v-56132d9e] {
  opacity: 0;
}
.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.combo .plus[data-v-56132d9e] {
  font-size: .5em;
  font-weight: 100;
  color: var(--dialer-color-special);
}
.dialer-wrapper .dialer .buttons[data-v-56132d9e] {
  display: flex;
  align-items: center;
  justify-content: center !important;
  padding: 5px;
}
.dialer-wrapper .dialer .buttons .dial-button[data-v-56132d9e] {
  display: flex;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  background-color: var(--dial-button-bgcolor);
  color: white;
  font-size: 27px;
  cursor: pointer;
}
.dialer-wrapper .dialer .buttons .dial-button i.fa-phone[data-v-56132d9e]::before {
  font-weight: 100;
}
@keyframes cepheid-56132d9e {
0% {
    opacity: 0;
}
49% {
    opacity: 0;
}
50% {
    opacity: 1;
}
100% {
    opacity: 1;
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/phone/Dialer.vue"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,uCAAuC;EACvC,aAAa;EACb,wDAAwD;EACxD,qDAAqD;EACrD,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA;EACE,uCAAuC;EACvC,aAAa;EACb,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,uCAAuC;EACvC,gDAAgD;EAChD,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,uCAAuC;AACzC;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA","sourcesContent":[".dialer-wrapper[data-v-56132d9e] {\n  position: fixed;\n  width: 100%;\n  z-index: 999;\n}\n.dialer-wrapper .dialer-contain[data-v-56132d9e] {\n  position: absolute;\n  top: var(--dialer-top);\n  left: var(--dialer-left);\n  background-color: var(--dialer-bgcolor);\n  z-index: 9999;\n  -webkit-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.75);\n  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.75);\n  border-radius: 10px;\n}\n.dialer-wrapper .dialer-contain[data-v-56132d9e]::before {\n  content: '';\n  position: absolute;\n  top: -13px;\n  left: var(--mouth-left);\n  width: 0;\n  height: 0;\n  border-top: 14px solid transparent;\n  border-right: 19px solid var(--dialer-bgcolor);\n}\n.dialer-wrapper .dialer[data-v-56132d9e] {\n  user-select: none;\n  overflow: hidden;\n  height: 500px;\n  width: 300px;\n}\n.dialer-wrapper .dialer .head[data-v-56132d9e] {\n  background-color: var(--dialer-bgcolor);\n  display: flex;\n  padding: 10px 20px 0px 15px;\n  height: 35px;\n}\n.dialer-wrapper .dialer .head .close-btn[data-v-56132d9e] {\n  margin: auto 0 auto auto;\n  opacity: .2;\n  cursor: pointer;\n}\n.dialer-wrapper .dialer .head .close-btn i[data-v-56132d9e] {\n  font-weight: 900;\n}\n.dialer-wrapper .dialer .phone-wrapper[data-v-56132d9e] {\n  margin: auto -20px;\n  height: 68px;\n  display: flex;\n  flex-direction: column;\n  font-size: .9em;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone[data-v-56132d9e] {\n  display: flex;\n  margin: 5px auto 0 auto;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .fake-caret[data-v-56132d9e] {\n  content: ' ';\n  width: .5px;\n  position: absolute;\n  height: 53.5px;\n  margin: -5px auto auto 48%;\n  background-color: var(--dialer-bgcolor);\n  animation: cepheid-56132d9e 1.2s linear infinite;\n  z-index: 9999;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .replace[data-v-56132d9e] {\n  position: absolute;\n  width: 267px;\n  margin-top: -13px;\n  margin-left: 34px;\n  text-align: center;\n  min-height: 68px;\n  padding: 0;\n  color: var(--dialer-input-color);\n  vertical-align: bottom;\n  display: flex;\n  align-items: flex-end;\n  background-color: var(--dialer-bgcolor);\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .replace.hide-fake-input[data-v-56132d9e] {\n  background: transparent;\n  pointer-events: none;\n  color: transparent;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .replace .fake-input[data-v-56132d9e] {\n  display: flex;\n  margin: auto;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .replace .fake-input-placeholder[data-v-56132d9e] {\n  display: flex;\n  margin: auto;\n  color: var(--custom-textarea-color);\n  font-weight: 400;\n  font-size: .8em;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .icon[data-v-56132d9e] {\n  display: flex;\n  opacity: 0;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .icon.show[data-v-56132d9e] {\n  opacity: 1;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .input[data-v-56132d9e] {\n  text-align: center;\n  min-height: 60px;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .input.show-true-input[data-v-56132d9e] {\n  color: #3F3F3F;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .input.show-true-input input[data-v-56132d9e]::selection {\n  background: #3F3F3F;\n  color: gray;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .input.show-true-input input[data-v-56132d9e]::-moz-selection {\n  background: #3F3F3F;\n  color: gray;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .input .phone-string[data-v-56132d9e] {\n  user-select: text;\n  text-align: center;\n  display: flex;\n  width: 240px;\n  min-height: 68px;\n  border: none;\n  outline: none;\n  margin-top: -13px;\n  margin-left: 45px;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .backspace[data-v-56132d9e] {\n  cursor: pointer;\n  display: flex;\n  margin: auto;\n  width: 48px;\n  font-size: 1.5em;\n  color: #ccc;\n  opacity: 0;\n  transition-property: opacity;\n  transition-duration: .25s;\n  position: relative;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .backspace.show[data-v-56132d9e] {\n  opacity: 1;\n  cursor: pointer;\n  transition-property: opacity;\n  transition-duration: .25s;\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .backspace i[data-v-56132d9e] {\n  position: absolute;\n  top: -8px;\n  left: -27px;\n  transform: translate(24px, -9px);\n}\n.dialer-wrapper .dialer .phone-wrapper .phone .backspace i.fa-backspace[data-v-56132d9e]::before {\n  font-weight: 100;\n}\n.dialer-wrapper .dialer .person-name[data-v-56132d9e] {\n  color: #7E7E7E;\n  display: flex;\n  margin: -20px auto;\n}\n.dialer-wrapper .dialer .dialpad[data-v-56132d9e] {\n  line-height: 70px;\n  height: 278px;\n}\n.dialer-wrapper .dialer .dialpad .dialpad-row[data-v-56132d9e] {\n  display: flex;\n  width: 100%;\n  margin: 15px auto;\n  color: var(--dialer-color);\n}\n.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col[data-v-56132d9e] {\n  width: 80px;\n  text-align: center;\n  margin: auto;\n  font-weight: 100;\n  font-size: 32px;\n  cursor: pointer;\n}\n.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.asterisk[data-v-56132d9e] {\n  color: var(--dialer-color-special);\n}\n.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.hash[data-v-56132d9e] {\n  color: var(--dialer-color-special);\n}\n.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.combo[data-v-56132d9e] {\n  display: flex;\n  flex-direction: column;\n  line-height: 25px;\n  transform: translateY(12.5px);\n}\n.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.combo .letters[data-v-56132d9e] {\n  font-size: 10px;\n  font-weight: 100;\n  color: var(--dialer-color-special);\n}\n.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.combo .letters.invisible[data-v-56132d9e] {\n  opacity: 0;\n}\n.dialer-wrapper .dialer .dialpad .dialpad-row .dialpad-col.combo .plus[data-v-56132d9e] {\n  font-size: .5em;\n  font-weight: 100;\n  color: var(--dialer-color-special);\n}\n.dialer-wrapper .dialer .buttons[data-v-56132d9e] {\n  display: flex;\n  align-items: center;\n  justify-content: center !important;\n  padding: 5px;\n}\n.dialer-wrapper .dialer .buttons .dial-button[data-v-56132d9e] {\n  display: flex;\n  border-radius: 50%;\n  width: 70px;\n  height: 70px;\n  background-color: var(--dial-button-bgcolor);\n  color: white;\n  font-size: 27px;\n  cursor: pointer;\n}\n.dialer-wrapper .dialer .buttons .dial-button i.fa-phone[data-v-56132d9e]::before {\n  font-weight: 100;\n}\n@keyframes cepheid-56132d9e {\n0% {\n    opacity: 0;\n}\n49% {\n    opacity: 0;\n}\n50% {\n    opacity: 1;\n}\n100% {\n    opacity: 1;\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
